import Translator from '../../classes/Translator/Translator';
const MoreInformationDemoLogic = () => {
  const { translator } = Translator();

  return {
    translator,
  };
};
export default MoreInformationDemoLogic;
